import { render, staticRenderFns } from "./OtpInput.vue?vue&type=template&id=4513fca6&scoped=true&"
import script from "./OtpInput.vue?vue&type=script&lang=js&"
export * from "./OtpInput.vue?vue&type=script&lang=js&"
import style0 from "./OtpInput.vue?vue&type=style&index=0&id=4513fca6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4513fca6",
  null
  
)

export default component.exports